import React, { useState } from 'react';
import { COMPANY } from '../constants/data';
import styles from './Contact.module.css';

const INIT = { name: '', phone: '', email: '', subject: '', message: '' };

export default function Contact() {
  const [form,    setForm]    = useState(INIT);
  const [errors,  setErrors]  = useState({});
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = 'Ad Soyad zorunludur.';
    if (!form.phone.trim())   e.phone   = 'Telefon zorunludur.';
    if (!form.email.trim())   e.email   = 'E-posta zorunludur.';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Geçerli bir e-posta girin.';
    if (!form.message.trim()) e.message = 'Mesaj zorunludur.';
    return e;
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    if (errors[name]) setErrors(er => ({ ...er, [name]: '' }));
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length > 0) { setErrors(e); return; }

    setApiError('');
    setLoading(true);

    try {
      // Kendi hostingindeki PHP script'ine gönderiyor — üçüncü servis yok
      const res = await fetch(`${process.env.PUBLIC_URL}/api/contact.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          phone: form.phone,
          email: form.email,
          subject: form.subject,
          message: form.message,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setSent(true);
      } else {
        setApiError(data.message || 'Mesaj gönderilemedi. Lütfen daha sonra tekrar deneyin.');
      }
    } catch (err) {
      setApiError('Bağlantı hatası. İnternet bağlantınızı kontrol edip tekrar deneyin veya bizi telefonla arayın.');
    } finally {
      setLoading(false);
    }
  };

  const INFO = [
    { icon: '📞', label: 'Telefon',         value: COMPANY.phone,     href: `tel:${COMPANY.phone}` },
    { icon: '📱', label: 'Cep Telefonu',    value: COMPANY.mobile,    href: `tel:${COMPANY.mobile.replace(/\s/g, '')}` },
    { icon: '📧', label: 'E-Posta',         value: COMPANY.email,     href: `mailto:${COMPANY.email}` },
    { icon: '📍', label: 'Adres',           value: COMPANY.address,   href: COMPANY.mapEmbed },
    { icon: '🕐', label: 'Çalışma Saatleri', value: COMPANY.workHours, href: null },
  ];

  return (
    <main className="page-wrapper">
      <div className="page-header">
        <div className={styles.headerInner}>
          <span className="eyebrow">Bize Ulaşın</span>
          <h1>İletişim</h1>
          <p className={styles.headerSub}>
            Sorularınız veya teklifiniz için bize ulaşın; ekibimiz en kısa sürede geri döner.
          </p>
        </div>
      </div>

      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.grid}>
            <div className={styles.infoCol}>
              {INFO.map((item, i) => (
                <div key={i} className={styles.infoCard}>
                  <div className={styles.infoIcon}>{item.icon}</div>
                  <div>
                    <div className={styles.infoLabel}>{item.label}</div>
                    {item.href
                      ? <a href={item.href} target={item.href.startsWith('http') ? '_blank' : '_self'}
                           rel="noreferrer" className={styles.infoVal}>{item.value}</a>
                      : <div className={styles.infoVal}>{item.value}</div>
                    }
                  </div>
                </div>
              ))}

              <div className={styles.socialBox}>
                <div className={styles.socialTitle}>Bizi Takip Edin</div>
                <div className={styles.socials}>
                  <a href={COMPANY.social.whatsapp} target="_blank" rel="noreferrer" className={styles.socialBtn}>💬 WhatsApp</a>
                  <a href={COMPANY.social.instagram} target="_blank" rel="noreferrer" className={styles.socialBtn}>📸 Instagram</a>
                  <a href={COMPANY.social.linkedin}  target="_blank" rel="noreferrer" className={styles.socialBtn}>💼 LinkedIn</a>
                </div>
              </div>
            </div>

            <div className={styles.formBox}>
              {sent ? (
                <div className={styles.success}>
                  <div className={styles.successIcon}>✅</div>
                  <h3 className={styles.successTitle}>Mesajınız İletildi!</h3>
                  <p className={styles.successDesc}>En kısa sürede sizinle iletişime geçeceğiz.</p>
                  <button className="btn-primary" onClick={() => { setForm(INIT); setSent(false); }}>
                    Yeni Mesaj Gönder
                  </button>
                </div>
              ) : (
                <>
                  <h2 className={styles.formTitle}>Bize Yazın</h2>

                  {apiError && (
                    <div className={styles.apiError}>⚠️ {apiError}</div>
                  )}

                  <div className={styles.formRow}>
                    <div className={styles.fieldWrap}>
                      <input
                        type="text" name="name" placeholder="Ad Soyad *"
                        value={form.name} onChange={handleChange}
                        className={`${styles.input} ${errors.name ? styles.inputError : ''}`}
                      />
                      {errors.name && <span className={styles.errorMsg}>{errors.name}</span>}
                    </div>
                    <div className={styles.fieldWrap}>
                      <input
                        type="tel" name="phone" placeholder="Telefon *"
                        value={form.phone} onChange={handleChange}
                        className={`${styles.input} ${errors.phone ? styles.inputError : ''}`}
                      />
                      {errors.phone && <span className={styles.errorMsg}>{errors.phone}</span>}
                    </div>
                  </div>
                  <div className={styles.fieldWrap}>
                    <input
                      type="email" name="email" placeholder="E-Posta Adresi *"
                      value={form.email} onChange={handleChange}
                      className={`${styles.input} ${errors.email ? styles.inputError : ''}`}
                    />
                    {errors.email && <span className={styles.errorMsg}>{errors.email}</span>}
                  </div>
                  <div className={styles.fieldWrap}>
                    <select
                      name="subject" value={form.subject} onChange={handleChange}
                      className={styles.input}
                    >
                      <option value="">Konu Seçiniz</option>
                      <option value="montaj">Asansör Montajı</option>
                      <option value="bakim">Periyodik Bakım</option>
                      <option value="modernizasyon">Modernizasyon</option>
                      <option value="muayene">Teknik Muayene</option>
                      <option value="diger">Diğer</option>
                    </select>
                  </div>
                  <div className={styles.fieldWrap}>
                    <textarea
                      name="message" rows={5} placeholder="Mesajınız *"
                      value={form.message} onChange={handleChange}
                      className={`${styles.input} ${styles.textarea} ${errors.message ? styles.inputError : ''}`}
                    />
                    {errors.message && <span className={styles.errorMsg}>{errors.message}</span>}
                  </div>
                  <button
                    className={`btn-primary ${styles.sendBtn}`}
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? 'Gönderiliyor…' : 'Mesaj Gönder'}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
